import { defineComponent as _defineComponent } from 'vue'
import { useValidator } from "@/core/app.service";
import Http from "@/core/http/http.service";
import { useTranslations } from "@/core/translate.mixin";
import { CordCutting } from "@/enums";
import { store } from "@/store";
import { computed, Ref, ref, watch } from "vue";
import AccordionContent from "@/ui/shared/accordion/components/AccordionContent.vue";
import CordAdjustment1 from "@/ui/icons/CordAdjustment1.vue";
import CordAdjustment2 from "@/ui/icons/CordAdjustment2.vue";
import CordAdjustment3 from "@/ui/icons/CordAdjustment3.vue";
import AccordionItem from "./accordion/AccordionItem.vue";
import CordCuttingSearchViewModel = Vertica.LouisPoulsen.Application.CordCutting.ViewModels.CordCuttingSearchViewModel;
import CordCuttingServiceProductViewObject = Vertica.LouisPoulsen.Application.CordCutting.ViewModels.CordCuttingServiceProductViewObject;


export default /*#__PURE__*/_defineComponent({
  __name: 'CordCuttingModal',
  props: {
    productId: null,
    showModal: { type: Boolean }
  },
  emits: ["submit", "close"],
  setup(__props: any, { emit }: { emit: ({(e: "submit", serviceProductId?: string, length?: string | null): void,
    (e: "close"): void
}), expose: any, slots: any, attrs: any }) {

const props = __props as {
    productId: string,
    showModal?: boolean
}




const cordCuttingLinkUrl = computed<string>(() => store.getters["app/cordCuttingLinkUrl"]);
const isPrivateMode = computed<boolean>(() => store.getters["app/isPrivateMode"]);

const step = ref<number>(1);
const cordCutting = ref<CordCutting>(CordCutting.Standard);
const standardCord = CordCutting.Standard;
const customCord = CordCutting.Custom;

const selectedServiceProductId = ref<string>("");
const customCordLength = ref<string>("");

const cordCuttingServiceProducts = ref<CordCuttingSearchViewModel[]>([]);
const selectedType = ref<{ [key: string]: boolean }>({});

const step1Namespace = "Shared.CordCuttingB2B.ModalStep1.Description";
const step2Namespace = "Shared.CordCuttingB2B.ModalStep2.Description";
const descriptionLines = [1, 2, 3];

const PlugType1 = "PlugType1";
const PlugType2 = "PlugType2";
const PlugType3 = "PlugType3";

function isSelected(serviceProduct: CordCuttingServiceProductViewObject) {
    return selectedServiceProductId.value === serviceProduct.id;
}

const refPrefix = "service-product-";
const accordions : { [key: string]: Ref } = {};

watch(() => props.showModal, initProducts);
function initProducts() {
    if (props.showModal) {
        Http.get<any>(`cordcutting/search?variantId=${props.productId}`)
            .then((response: CordCuttingSearchViewModel[]) => {
                cordCuttingServiceProducts.value = response;
            });
    }
}

const useStandardLength = computed<boolean>(() => {
    return cordCutting.value === standardCord;
});

const $validator = useValidator();

const validateCordLength = computed(() => (product: CordCuttingSearchViewModel, serviceProduct: CordCuttingServiceProductViewObject) => {
    const validation : any = {
        required: selectedType[product.plugType],
        regex: /\d*0$/,
        max: 10
    };
    if (serviceProduct.minimumCordLength) {
        validation.min_value = serviceProduct.minimumCordLength;
    }
    if (serviceProduct.maximumCordLength) {
        validation.max_value = serviceProduct.maximumCordLength;
    }
    return validation;
});

function onSelectedTypeChange(plugType: any, value: boolean) {
    $validator.reset();
    const object = Object.assign({}, selectedType.value);
    object[plugType] = value;
    selectedType.value = object;
    if (Object.values(selectedType.value).filter(_ => _).length > 1) {
        Object.keys(selectedType.value).forEach(type => {
            if (type !== plugType) {
                const object = Object.assign({}, selectedType.value);
                object[type] = false;
                selectedType.value = object;
            }
        });
    }
}

const plugOnly = computed<boolean>(() => {
    const selectedPlugType = cordCuttingServiceProducts.value.find(p => selectedType.value[p.plugType]);
    if (!selectedPlugType) return false;
    const selectedServiceProduct = selectedPlugType.cordCuttingServiceProducts.find(isSelected);
    return selectedServiceProduct && selectedServiceProduct.plugOnly;
});

function selectCord() {
    if (useStandardLength.value) {
        emit("submit");
        closeOverlay();
    } else {
        step.value = 2;
        cordCuttingServiceProducts.value.forEach(x => accordions[refPrefix + x.plugType] = ref(null));
    }
}

function selectPlug() {
    $validator.validateAll()
        .then(isValid => {
            if (isValid) {
                emit("submit", selectedServiceProductId.value, plugOnly.value ? null : customCordLength.value);
                closeOverlay();
                customCordLength.value = "";
            }
        })
        .catch(x => console.log("catch" + x));
}

function setAccordionRef(plugType: string) {
    return (el: any) => {
        setTimeout(() => {
            accordions[refPrefix + plugType].value = el;
        }, 100);
    };
}

function resetChoices() {
    cordCutting.value = standardCord;
    step.value = 1;
}

function closeOverlay() {
    emit("close");
    setTimeout(resetChoices, 400);
}

const { t } = useTranslations();

function hasDescription(namespace: string) : boolean {
    return descriptionLines.some(lineNo => !!t(`${namespace}.Line${lineNo}`));
}

function getLine(namespace: string, lineNo: number) : string {
    return t(`${namespace}.Line${lineNo}`).replace("{0}", cordCuttingLinkUrl.value || "");
}

return { __sfc: true,props, emit, cordCuttingLinkUrl, isPrivateMode, step, cordCutting, standardCord, customCord, selectedServiceProductId, customCordLength, cordCuttingServiceProducts, selectedType, step1Namespace, step2Namespace, descriptionLines, PlugType1, PlugType2, PlugType3, isSelected, refPrefix, accordions, initProducts, useStandardLength, $validator, validateCordLength, onSelectedTypeChange, plugOnly, selectCord, selectPlug, setAccordionRef, resetChoices, closeOverlay, t, hasDescription, getLine, AccordionContent, CordAdjustment1, CordAdjustment2, CordAdjustment3, AccordionItem }
}

})